import type { ActivityModule } from '../../core/activity';
import { runAlgebraActivity } from '../../shared/algebra-runner';
import type { AlgebraLevel } from '../../shared/algebra-runner';
import levelsData from './levels.json';

export const algebraDiv: ActivityModule = {
  id: 'algebra_div',
  title: 'Divisão',
  description: 'Divida números inteiros usando tabuadas progressivas. Resultado sempre exato.',
  ageMin: 8,
  ageMax: 11,
  difficulty: 6,
  iconPath: 'assets/gcompris-AGPL/algebra_div/icon.svg',
  category: 'aritmetica',
  totalLevels: levelsData.levels.length,
  mount(ctx) {
    return runAlgebraActivity(ctx, {
      activityId: 'algebra_div',
      title: 'Divisão',
      operator: '÷',
      compute: (a, b) => (b === 0 ? NaN : a / b),
      levels: levelsData.levels as AlgebraLevel[],
    });
  },
};
